import React from "react";

export const Button = ({ canClick, isLoading, actionText }) => (
  <button
    className={`w-1/3 mt-20 text-2xl text-white py-4  ${
      canClick
        ? "text-white bg-[#eed495]"
        : "bg-gray-600 pointer-events-none"
    }`}
  >
    {isLoading ? "Logging In" : actionText}
  </button>
);
